import { useState } from 'react';
import { useAuth } from '@/lib/auth';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { CalendarRange, LogIn } from 'lucide-react';

export default function LoginPage() {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(username.trim(), password);
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === 'string' ? d : 'Prihlásenie zlyhalo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4" data-testid="login-page">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <div className="w-11 h-11 rounded-lg bg-white text-slate-900 flex items-center justify-center">
            <CalendarRange className="w-6 h-6" />
          </div>
          <div className="text-white">
            <div className="font-bold text-lg leading-tight">Plánovač zmien</div>
            <div className="text-[11px] text-slate-400 leading-tight">Automatizovaný rozvrh · Zákonník práce SR</div>
          </div>
        </div>

        <form onSubmit={submit} className="bg-white rounded-xl shadow-xl p-6 space-y-4" data-testid="login-form">
          <div className="space-y-1.5">
            <Label htmlFor="username" className="text-slate-700">Prihlasovacie meno</Label>
            <Input id="username" data-testid="login-username" value={username}
              onChange={(e) => setUsername(e.target.value)} autoFocus autoComplete="username"
              placeholder="nickname" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password" className="text-slate-700">Heslo</Label>
            <Input id="password" data-testid="login-password" type="password" value={password}
              onChange={(e) => setPassword(e.target.value)} autoComplete="current-password"
              placeholder="••••••••" />
          </div>
          {error && (
            <div data-testid="login-error" className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2">
              {error}
            </div>
          )}
          <Button type="submit" data-testid="login-submit" disabled={loading || !username || !password}
            className="w-full bg-slate-900 hover:bg-slate-800">
            <LogIn className="w-4 h-4 mr-2" />
            {loading ? 'Prihlasujem…' : 'Prihlásiť sa'}
          </Button>
          <p className="text-xs text-slate-400 text-center pt-1">
            Prihlásenie pre správcov (link z TiDo) bude dostupné neskôr.
          </p>
        </form>
      </div>
    </div>
  );
}
